//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export class ODSChartsThemeObserver {
    constructor(echart, redraw) {
        this.echart = echart;
        this.redraw = redraw;
    }
    static addThemeObserver(echart, redraw) {
        return new ODSChartsThemeObserver(echart, redraw);
    }
    get divElement() {
        let div;
        try {
            div = this.echart.getDom();
        }
        catch (error) { }
        if (!div) {
            this.removeListener();
        }
        return div;
    }
    addThemeObserver() {
        this.removeListener();
        let div = this.divElement;
        if (div && MutationObserver) {
            div = div.closest('[data-bs-theme]') || undefined;
            if (div) {
                this.observer = new MutationObserver(this.observeAttributeChange.bind(this));
                this.observer.observe(div, { attributes: true, childList: false, subtree: false });
            }
        }
        return div;
    }
    removeListener() {
        try {
            if (this.observer) {
                this.observer.disconnect();
            }
        }
        catch (error) {
        }
        finally {
            this.observer = undefined;
        }
    }
    observeAttributeChange(mutations, _observer) {
        try {
            if (this.divElement) {
                if (mutations.find((mutation) => mutation.type === 'attributes' && mutation.attributeName === 'data-bs-theme')) {
                    this.redraw();
                }
            }
        }
        catch (error) {
            this.removeListener();
        }
    }
}
